export default __webpack_public_path__ + "empty-job-pending-md.e493f75e.svg";